<template>
    <DModal
        :title="__('customers.customers.cloudpit_onetime_modal.title')"
        is-medium
        @close="closeModal"
    >
        <DCard padding>
            <DTable
                :items="users"
                :fields="fields"
            >
                <template #firstname="{item}">
                    <td>
                        {{ item.contact.firstname }}
                    </td>
                </template>
                <template #lastname="{item}">
                    <td>
                        {{ item.contact.lastname }}
                    </td>
                </template>
                <template #actions="{item}">
                    <td>
                        <div
                            v-if="userPermissions.includes('customer.view')"
                            style="display: flex; grid-gap: 10px"
                        >
                            <DButton
                                color="primary"
                                :label="__('customers.customers.cloudpit_onetime_modal.button')"
                                :disabled="isInLoadingState"
                                @click="sendOneTimeLoginToUser(item)"
                            />
                        </div>
                    </td>
                </template>
            </DTable>
        </DCard>
    </DModal>
</template>

<script setup>

import { computed, ref } from 'vue'
import { route } from '~@/Composables/route'
import { usePage } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    customer: {
        type: Object,
        default: () => { return {} }
    },
    users: {
        type: Array,
        default: () => { return [] }
    }
})

const emit = defineEmits(['close-modal', 'axios-message'])

const fields = ref([
    { key: 'firstname', label: 'First name' },
    { key: 'lastname', label: 'Last name' },
    { key: 'email', label: 'Email' },
    { key: 'actions', label: '' }
])

const userPermissions = computed(() => usePage().props.auth.permissions)

const sendOneTimeLoginToUser = function (user) {
    window.axios.post(
        route('customers.customers.cloudpit_onetime_login', { customer: props.customer.id }),
        { user_id: user.id }
    ).then(() => {
        emitMessage(
            true,
            __('customers.customers.cloudpit_onetime_login_success'),
            true
        )
    })
        .catch((error) => {
            const message = (error && error.response && error.response.data.message.length > 0)
                ? error.response.data.message
                : __('customers.customers.cloudpit_onetime_login_error')

            emitMessage(
                true,
                message,
                false
            )
        })
}

const emitMessage = function (showMessage, message, success) {
    emit('axios-message', {
        showMessage: showMessage,
        message: message,
        success: success
    })
}

const closeModal = function () {
    emit('close-modal')
}
</script>

<style scoped>

</style>
